import React from 'react';
import {EfeTooltip} from 'components';
type TooltipPosition =
    | 'left-end'
    | 'right-end'
    | 'left'
    | 'right'
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'top';

export const setTooltip = (
    children: JSX.Element,
    flag: boolean,
    title: string,
    arrowPlacement?: TooltipPosition
) => {
    if (flag) {
        return (
            <EfeTooltip arrow={true} title={title} placement={arrowPlacement}>
                {children}
            </EfeTooltip>
        );
    } else {
        return children;
    }
};
